var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { css, keyframes } from "@emotion/core";
import "focus-visible";
import { generateColorScale } from "./colors";
import { elevation, getElevation } from "./elevation";
import { between, greaterThan, lessThan } from "./mediaQueries";
import { em, emRhythm, rem, remRhythm } from "./rhythm";
import { allProps, color, getPx, textTransform, toPx } from "./styledSystem";
export { generateColorScale, getElevation, color, elevation, greaterThan, lessThan, between, rem, remRhythm, em, emRhythm, allProps, getPx, textTransform, toPx };
export var spin = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
export function switchOn(key, config, defaultValue) {
  return config[key] || defaultValue;
}
/* See: https://github.com/WICG/focus-visible */

var _ref = {
  name: "1ylcy4g-hide-focus-ring",
  styles: "label:hide-focus-ring;.js-focus-visible &:focus:not([data-focus-visible-added]){outline:none;}"
};
export function hideFocusRingOnClick() {
  return _ref;
}
export var ellipsis = {
  name: "xngti1-ellipsis",
  styles: "label:ellipsis;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
};
export var hiddenOffScreen = {
  name: "4l8hb3-hidden-off-screen",
  styles: "label:hidden-off-screen;position:absolute;top:auto;left:-99999px;"
};
export var alignIconToText = {
  name: "u2ugh2-align-icon-to-text",
  styles: "label:align-icon-to-text;position:relative;top:0.125em;"
};
export var noBullets = {
  name: "1n46icc",
  styles: "padding-left:0;list-style:none;"
};
export var pieClearfix = {
  name: "14zlpy1",
  styles: "&:after{content:\"\";display:table;clear:both;}"
};